import styled from 'styled-components';
import { colours, media, spacing } from '@storefront/lib-global/stylings';

export const SizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXXS};
  scroll-margin-top: 50px;
  width: 100%;

  @media ${media.greaterThan('lg')} {
    scroll-margin-top: 54px;
  }
`;
export const CrossedLine = styled.hr`
  border: none;
  border-top: 1px solid ${colours.GREY};
  left: 50%;
  position: absolute;
  transform-origin: center;
`;
